<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div
      class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25"
    >
      <div class="d-sm-flex align-items-center">
        <router-link
          to="/add-product"
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 bg-success fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
        >
          Nouveau Produit
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </router-link>
      </div>
      
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-scroll-outer">
        <div class="table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0"
              >
                Produit
              </th>
              
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Nom du produit
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Quantité
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Statut
              </th>

              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"
              >
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, index) in rows" :key="index">
              <th class="shadow-none fw-medium text-black title ps-0">
                <div class="d-flex align-items-center">
                  <router-link
                    to="/product-details"
                    class="d-flex align-items-center text-decoration-none text-black ms-8 fs-md-15 fs-lg-16"
                  >
                    <img :src="row.pic" class="me-15" width="44" v-if="row.pic" />
                    <img  :src="require('@/assets/images/NoImage.png')" class="me-15" width="44" v-else />
                    
                  </router-link>
                </div>
              </th>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ row.name }}
              </td>
              
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span v-for="item in row.inventories" :key="item.id">
                  <center>
                    <b>{{ item.inventory_ref }}</b> {{ item.qty }} |
                    {{ item.qty_not_received }}
                    <span
                      class="badge bg-outline-danger"
                      v-if="item.archived == 1"
                    >
                      Archivé </span
                    ><br />
                  </center>
                </span>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <span
                  v-if="row.received == 1"
                  class="badge text-bg-success rounded-pill"
                >
                  Reçu
                </span>

                <span class="badge text-bg-warning rounded-pill" v-else>
                  Pas encore reçu
                </span>
              </td>
              
              <td
                class="shadow-none lh-1 fw-medium text-paragraph text-end pe-0"
              >
                <div class="dropdown">
                  <button
                    class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <li>
                      <a
                        class="dropdown-item d-flex align-items-center"
                        @click.prevent="
                          $router.push({
                            name: 'EditProductPage',
                            params: { id: row.id },
                          })
                        "
                        ><i
                          class="flaticon-pen lh-1 me-8 position-relative top-1"
                        ></i>
                        Modifier</a
                      >
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </div>
      <div
        class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center"
      >
        <p class="mb-0 text-paragraph">
          Showing
          <span class="fw-bold">
            {{ (filter.current_page - 1) * filter.per_page + 1 }}
          </span>
          –
          <span class="fw-bold">
            {{ Math.min(filter.current_page * filter.per_page, filter.total) }}
          </span>
          out of <span class="fw-bold">{{ filter.total }}</span> results
        </p>

        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <!-- Previous -->
            <li
              class="page-item"
              :class="{ disabled: filter.current_page === 1 }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Previous"
                @click="goToPage(filter.current_page - 1)"
              >
                ‹
              </a>
            </li>

            <!-- First page -->
            <li v-if="pages[0] !== 1" class="page-item">
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(1)"
                >1</a
              >
            </li>

            <!-- Left dots -->
            <li v-if="pages[0] > 2" class="page-item disabled">
              <span class="page-link">...</span>
            </li>

            <!-- Main pages -->
            <li v-for="page in pages" :key="page" class="page-item">
              <a
                href="javascript:void(0)"
                class="page-link"
                :class="{ active: filter.current_page === page }"
                @click="goToPage(page)"
              >
                {{ page }}
              </a>
            </li>

            <!-- Right dots -->
            <li
              v-if="pages[pages.length - 1] < filter.last_page - 1"
              class="page-item disabled"
            >
              <span class="page-link">...</span>
            </li>

            <!-- Last page -->
            <li
              v-if="pages[pages.length - 1] !== filter.last_page"
              class="page-item"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                @click="goToPage(filter.last_page)"
              >
                {{ filter.last_page }}
              </a>
            </li>

            <!-- Next -->
            <li
              class="page-item"
              :class="{ disabled: filter.current_page === filter.last_page }"
            >
              <a
                class="page-link"
                href="javascript:void(0)"
                aria-label="Next"
                @click="goToPage(filter.current_page + 1)"
              >
                ›
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

</template>

<script  lang="ts">
import { onMounted, reactive, ref } from "vue";
import flatpickr from "flatpickr";
import { useAuthStore } from "../../stores/auth";
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import moment from "moment";
import { computed } from "vue";
import { Modal } from "bootstrap";

export default {
  name: "ProductListPage",
  components: {},
  setup: () => {
    const { showToast } = useAppToast();
    const auth = useAuthStore();
    const user = auth.user;

    const rows = ref([]);
    const isLoader = ref(false);

    const filter = reactive({
      surrent_page: 1,
      per_page: 10,

      searchTerm: "",

      // (optional) pagination/meta from API:
      total: 0,
      last_page: 1,
      current_page: 1,
    });

    const searchTerm = ref("");

    interface Status {
      code: string;
      name: string;
      code_color?: string;
    }

    const status = ref<Status[]>([]);

    const clientList = ref<Status[]>([]);
    const agenciesList = ref<Status[]>([]);

    const fields = [
      { key: "inventory_ref", label: "Variante" },
      { key: "qty", label: "Quantité Restée" },
      { key: "qty_not_received", label: "Quantité Reçue" },
      { key: "statut", label: "Statut" },
      { key: "actions", label: "Archiver" },
    ];
    const inventoriesRow = ref([]);

    function getDate(value) {
      if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
      else return "";
    }

    function buildQuery() {
      const params = new URLSearchParams({
        searchTerm: filter.searchTerm || "",

        page: String(filter.current_page || 1),
        per_page: String(filter.per_page || 10),
      });
      return `/api/auth/client/list_product?${params.toString()}`;
    }

    onMounted(async () => {
      flatpickr("#lead-calendar", {
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d",
        defaultDate: "today",
      });

      flatpickr("#basic-calendar", {
        dateFormat: "Y-m-d H:i",
      });
      getRecords();
    });

    const pages = computed(() => {
      const windowSize = 2; // show 2 before/after current page
      const start = Math.max(1, filter.current_page - windowSize);
      const end = Math.min(filter.last_page, filter.current_page + windowSize);

      let arr = [];
      for (let i = start; i <= end; i++) {
        arr.push(i);
      }
      return arr;
    });

    async function getRecords() {
      isLoader.value = true;
      try {
        const url = buildQuery();
        const { data } = await api.get(url);

        rows.value = data.products.data;

        // Keep your search fields; only update pagination/meta you need:
        filter.current_page = data.products.current_page;
        filter.per_page = data.products.per_page;
        filter.total = data.products.total;
        filter.last_page = data.products.last_page;

        // If you actually need all fields returned from backend:
        // Object.assign(users, { ...users, ...data.users })
      } finally {
        isLoader.value = false;
      }
    }

    function filterList() {
        filter.searchTerm = searchTerm.value || "";
      filter.current_page = 1;
      getRecords();
    }

    function removeFilter() {
      // reset users filters

        filter.searchTerm = "";
      filter.current_page = 1;

      // reset local UI models

      searchTerm.value = "";

      getRecords();
    }

   

    function goToPage(page) {
      if (page < 1 || page > filter.last_page) return;
      filter.current_page = page;
      getRecords();
    }

    function globalHelper(s: string) {
      if (!s || s === "undefined") {
        return null; // always return null for invalid values
      }
      return status.value.find((o) => o.code === s) || null;
    }

    function removeHours(value) {
      if (value && value !== "") {
        const datePart = value.split(" ")[0];
        return datePart;
      }
    }
    function reported(date) {
      const currentDate = new Date();
      const reportedDate = new Date(date);
      if (reportedDate.getTime() <= currentDate.getTime()) {
        return true;
      } else {
        return false;
      }
    }
   

    

    return {
      auth,
      rows,
      goToPage,
      filter,
      getDate,
      globalHelper,
      removeHours,
      reported,

      searchTerm,

      clientList,
      status,

      filterList,
      removeFilter,

      pages,
      fields,
      inventoriesRow,
    };
  },
};
</script>
